module.exports = __webpack_public_path__ + "img/samsung_step4.d5e9add6.png";